export enum DataCloudEventTypeValues {
    identity = 'identity',
    customEvent = 'customEvent',
    searchEvent = 'searchEvent',
    impression = 'impression',
    aiOverviewFeedback = 'feedback',
    aiOverviewSuggestedClick = 'suggestedClick',
    aiOverviewCardClick = 'cardClick',
    streamComplete = 'streamComplete',
    streamError = 'streamError',
    collapse = 'collapse',
    expand = 'expand',
    mobileToggle = 'mobileToggle',
    retry = 'retry',
}

export enum DataCloudEventSource {
    site = 'Site',
}

// Shared `interaction.name` for all AI Overview Data Cloud events (impression
// and future click/feedback events), discriminated by `eventType`.
export const AI_OVERVIEW_EVENT_NAME = 'aiOverviewEvent';

// `aiOverviewExpandSource` values for the expand and mobileToggle actions.
export const AI_OVERVIEW_EXPAND_SOURCE_STICKY_BAR = 'stickyBar';
export const AI_OVERVIEW_EXPAND_SOURCE_MOBILE_EXPAND = 'mobileToggle:expand';
export const AI_OVERVIEW_EXPAND_SOURCE_MOBILE_COLLAPSE = 'mobileToggle:collapse';

// `aiOverviewErrorToken` values for the retry action. The store derives the
// token from the failure's HTTP status; opaque failures (SSE error event,
// network drop) that carry no status fall back to 'unknown'.
export const AI_OVERVIEW_ERROR_TOKENS = [
    'service_unavailable',
    'rate_limited',
    'upstream_timeout',
    'validation_error',
    'unknown',
] as const;
export type AiOverviewErrorToken = (typeof AI_OVERVIEW_ERROR_TOKENS)[number];
export const AI_OVERVIEW_ERROR_TOKEN_FALLBACK: AiOverviewErrorToken = 'unknown';

export const DATA_CLOUD_CASE_STUDY_TYPE = 'caseStudy';
export const DATA_CLOUD_UNINSTALL_TYPE = 'uninstall';
export const DATA_CLOUD_DATA_SHEET_TYPE = 'dataSheet';
export const DATA_CLOUD_WEBINAR_TYPE = 'webinar';
export const DATA_CLOUD_TESTIMONIAL_TYPE = 'testimonial';
export const DATA_CLOUD_APP_INSTALL_TYPE = 'appInstall';
export const DATA_CLOUD_TEST_DRIVE_TYPE = 'testDrive';
export const DATA_CLOUD_WHITE_PAPER_TYPE = 'whitePaper';
